<!-- 薪资发放 -->
<template>
    <section>
        <section class="search-container">
            <a-form layout="inline" class="m-t-14">
                <a-form-item label="所属单位">
                    <a-select class="search-select" placeholder="全部" v-model="searchInfo.companyId">
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option v-for="item in companyMap" :key="item.id" :value="item.id">{{item.companyName}}</a-select-option>
                    </a-select>
                    
                </a-form-item>
                
                <a-form-item label="车辆类型">
                    <a-select class="search-select" placeholder="全部" v-model="searchInfo.carType">
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option v-for="item in carTypeLists" :key="item.id" :value="item.id">{{item.carTypeName}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item  label="进出状态">
                    <a-select class="search-select" placeholder="全部" v-model="searchInfo.inOutType" >
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option :value="1">进入工地</a-select-option>
                        <a-select-option :value="2">离开工地</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="标识">
                    <a-select class="search-select" placeholder="全部" v-model="searchInfo.carStatus" >
                        <a-select-option value="">全部</a-select-option>
                        <a-select-option :value="0">正常</a-select-option>
                        <a-select-option :value="1">陌生</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="车牌号">
                    <a-input class="search-input" placeholder="请输入" v-model="searchInfo.carNumber" />
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" class="m-r-8" @click="search"><a-icon type="search" />查询</a-button>
                    <a-button @click="reset"><a-icon type="reload" />重置</a-button>
                    <a-button class="item" @click="exprotFile('exportCarLogList', {params: searchInfo})" style="margin-left: 8px">
                        <a-icon type="export" />
                        导出
                    </a-button>
                </a-form-item>
            </a-form>
        </section>

        <section class="list-table-container m-t-18">
            <a-table size="small" :columns="columns" :data-source="listMap" :pagination="{total,pageSize,hideOnSinglePage:true,showTotal:(total) => `共${total}条`,size:'default',showQuickJumper:true,showSizeChanger:false}" @change="changePageNum">
                <span slot="carStatus" slot-scope="text">{{text === 0 ? '正常车辆' : '陌生车辆'}}</span>
                <span slot="inOutType" slot-scope="text">{{text === 1 ? '进入工地' : '离开工地'}}</span>
                <a-row slot="logImage" slot-scope="text">
                    <previewImage :data="text" :size="40" />
                </a-row>
            </a-table>
        </section>
    </section>
</template>

<script>
const columns = [
    {title:'序号',dataIndex:'key',align:'center',key:'key'},
    {title:'出入口名称',dataIndex:'doorwayName',align:'center',key:'doorwayName'},
    {title:'所属单位',dataIndex:'companyName',align:'center',key:'companyName'},
    {title:'车辆类型',dataIndex:'carTypeName',align:'center',key:'carTypeName'},
    {title:'车牌号',dataIndex:'carNumber',align:'center',key:'carNumber'},
    {title:'进出时间',dataIndex:'createTime',align:'center',key:'createTime'},
    {title:'进出状态',dataIndex:'inOutType',align:'center',key:'inOutType',scopedSlots:{customRender: "inOutType"}},
    {title:'标识',dataIndex:'carStatus',align:'center',key:'carStatus',scopedSlots:{customRender: "carStatus"}},
    {title:'通行图像',dataIndex:'logImage',align:'center',key:'logImage',scopedSlots:{customRender: "logImage"}}
]
import moment from 'moment'
import previewImage from '@/components/previewImage'
import { exprotFile } from '@/until/unit'
export default {
    data(){
        return{
            total:0,
            pageNum:1,
            pageSize:9,
            columns,
            listMap:[],
            companyMap:[],
            carTypeLists:[],
            searchInfo:{}
        }
    },
    components:{previewImage},
    created(){
        this.init()
    },
    mounted(){
        this.queryCarLogList()
    },
    methods:{
        exprotFile,
        init(){
            this.queryCompanyDropDownBox()
            this.queryCarTypeList()
        },
        //查询车辆类型列表
        queryCarTypeList(){
            let params =  {...this.searchInfo}
            params.current = this.pageNum
            this.$api.queryCarTypeList(params).then(res =>{
                if(res.code === 200){
                    this.carTypeLists = res.data || []
                }
            })
        },
        //单位下拉
        queryCompanyDropDownBox(){
            this.$api.queryCompanyDropDownBox().then(res =>{
                if(res.code === 200){
                    this.companyMap = res.data || []
                }
            })
        },
        queryCarLogList(){
            let params = {...this.searchInfo}
            params.current = this.pageNum
            params.size = this.pageSize
            this.$api.queryCarLogList(params).then(res =>{
                if(res.code === 200){
                    this.listMap = (res.data && res.data.records) || []
                    this.total = (res.data && res.data.total) || 0
                    this.listMap.forEach((item,ind) =>{
                        item.key = (this.pageNum-1)*this.pageSize + (ind+1)
                        item.createTime = moment(item.createTime).format('YYYY-MM-DD HH:mm:SS')
                    })
                }
            })
        },
        reset(){
            this.searchInfo = {}
            this.pageNum = 1
            this.queryCarLogList()
        },
        search(){
            this.pageNum = 1
            this.queryCarLogList()
        },
        //分页
        changePageNum(p){
            this.pageNum = p.current
            this.queryCarLogList()
        }
    }
}
</script>